var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TypeOverline',{staticClass:"text-[13px] tracking-[3px] text-center text-secondaryBrandDefault xl:text-left whitespace-nowrap md:whitespace-normal mb-[19px]",attrs:{"tag":"p","variant":"large"}},[_vm._v("\n  "+_vm._s(_vm.headline)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }